import { useQuery } from '@apollo/client'
import { CircularProgress, Modal, Paper, Slide } from '@material-ui/core'

import SectionTitle from '../../../components/SectionTitle'
import { ALLOCATION_SYSTEM_RESERVES } from '../../../graphql/inventoryAllocateAvailability'
import { getDirection } from '../../../localization'
import {
  AllocationSystemReservesInput,
  SystemReservation
} from '../../../types/inventoryAllocatedList'
import ReservationNumbersModalRow from './ReservationNumbersModalRow'
import ReservationNumbersModalTableHead from './ReservationNumbersModalTableHead'
import useStyles from './styles/index.styles'

interface ReservationNumbersModalProps {
  isOpen: boolean
  onClose: () => void
  input: AllocationSystemReservesInput
}
const ReservationNumbersModal: React.FC<ReservationNumbersModalProps> = ({
  isOpen,
  onClose,
  input
}) => {
  const classes = useStyles()

  const { data } = useQuery<{
    allocationSystemReserves: SystemReservation[]
  }>(ALLOCATION_SYSTEM_RESERVES, {
    variables: {
      input: input
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache'
  })

  return (
    <Modal dir={getDirection()} open={isOpen} onClose={onClose}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.paper}>
          <div className={classes.titleContainer}>
            <SectionTitle title="Reservation Numbers" marginBottom />
          </div>
          <ReservationNumbersModalTableHead />
          {data ? (
            <>
              {data?.allocationSystemReserves.map((item, index) => (
                <ReservationNumbersModalRow data={item} index={index} />
              ))}
            </>
          ) : (
            <div className={classes.circularProgressContianer}>
              <CircularProgress color="primary" />
            </div>
          )}
        </Paper>
      </Slide>
    </Modal>
  )
}

export default ReservationNumbersModal
